<div class="item answer-next traversable-list-item"
     *ngIf="!answerNextInProgress && !isQueueEmpty()"
     [attr.tabindex]="0"
     (click)="onAnswerNextClicked()"
     (keydown)="onAnswerNextKeydown($event)">
  <span class="answer-next-text">{{'workitemAnswerNext.answerNext.' + friendlyWorkItemTypeName + '.takeNext' | translate}}</span>
  <div class="queue-size">{{itemQueue.length}}</div>
</div>
<div class="item answer-next disabled"
     *ngIf="answerNextInProgress || isQueueEmpty()">
  <span *ngIf="isQueueEmpty() && !answerNextInProgress" class="answer-next-text">{{'workitemAnswerNext.answerNext.' + friendlyWorkItemTypeName + '.emptyQueue' | translate }}</span>
  <span *ngIf="answerNextInProgress" class="answer-next-text">{{'workitemAnswerNext.answerNext.' + friendlyWorkItemTypeName + '.takeNext' | translate }}</span>
  <div class="queue-size">
    <svg-icon icon="checkmark" *ngIf="isQueueEmpty() && !answerNextInProgress"></svg-icon>
    <svg-icon icon="refresh" *ngIf="answerNextInProgress"></svg-icon>
  </div>
</div>
